import produce from 'immer';
import { Actions } from './action';
import { AddressValidationActions } from './enum';
import { AddressValidationState } from './interface';
import { getAddressForm, getSelectedAddress, getSuggestions } from './util/reducer';
import { areObjectsDeeplyEqual } from '@vfde-sails/utils';

export const initialState: AddressValidationState = {
    addressForm: {
        city: '',
        street: '',
        housenumber: '',
    },
    addresses: undefined,
    selectedAddress: undefined,
    inputSuggestions: {
        city: [],
        street: [],
    },
    productSuggestion: undefined,
    error: undefined,
};

const addressValidationReducer = (state: AddressValidationState = initialState, action: Actions) =>
    produce(state, (draftState) => {
        switch (action.type) {
            case AddressValidationActions.SET_ADDRESSES:
                draftState.addresses = action.addresses;
                draftState.selectedAddress = action.addresses[0];

                if (draftState.selectedAddress) {
                    draftState.addressForm = getAddressForm(draftState.selectedAddress);
                }

                break;
            case AddressValidationActions.SET_FORM:
                const newForm = {
                    ...draftState.addressForm,
                    ...action.form,
                };

                if (!areObjectsDeeplyEqual(draftState.addressForm, newForm)) {
                    draftState.addressForm = newForm;
                    draftState.selectedAddress = undefined;
                }

                break;
            case AddressValidationActions.SET_SELECTED_ADDRESS:
                draftState.selectedAddress = draftState.addresses?.[action.index];
                draftState.inputSuggestions = getSuggestions(draftState.addressForm, draftState.inputSuggestions);

                if (draftState.selectedAddress) {
                    draftState.addressForm = getAddressForm(draftState.selectedAddress);
                }

                break;
            case AddressValidationActions.CHANGE_ADDRESS:
                draftState.productSuggestion = undefined;
                draftState.addresses = undefined;
                break;
            case AddressValidationActions.DELETE_ADDRESS:
                draftState.addressForm = initialState.addressForm;
                draftState.inputSuggestions = initialState.inputSuggestions;
                draftState.selectedAddress = undefined;
                draftState.addresses = undefined;
                draftState.productSuggestion = undefined;
                break;
            case AddressValidationActions.SET_JARVIS_RESPONSE:
                draftState.productSuggestion = action.response.suggestion;
                draftState.selectedAddress = getSelectedAddress(action.response);
                draftState.addresses = action.response.addresses;
                draftState.error = undefined;
                break;
            case AddressValidationActions.SET_JARVIS_ERROR:
                draftState.productSuggestion = undefined;
                draftState.selectedAddress = undefined;
                draftState.addresses = undefined;
                draftState.error = action.error;
                break;
        }
    });

export default addressValidationReducer;
